module.exports = __webpack_public_path__ + "static/media/newCandidate.1a5410b7.svg";